import PuestosApi from '../../apis/Puestos';

export default {
    namespaced: true,
    state: {
        puestos: [],
        puestosActivo: []
    },
    mutations: {
        set_puestos (state, puestos) {
            state.puestos = puestos
        },
        set_puestosActivos (state, puestosActivo) {
            state.puestosActivo = puestosActivo
        }
    },
    actions: {
        async getPuestos({commit, dispatch}, filters) {
            return await PuestosApi.get_all(filters)
                            .then( response => {
                                commit('set_puestos', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async store({dispatch}, puesto) {
            return await PuestosApi.store(puesto)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getPuestos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async update({dispatch}, puesto) {
            return await PuestosApi.update(puesto)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true})
                                dispatch('getPuestos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async change_status({dispatch}, puesto) {
            let action = (puesto.activo) ? 'inactivación' : 'activación';
            return await PuestosApi.change_status(puesto)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La '+ action + ' se relizó de forma correcta.'
                                }, {root: true})
                                dispatch('getPuestos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root:true})
                            })
        },
        async delete({dispatch}, puesto) {
            return await PuestosApi.delete(puesto)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root:true})
                                dispatch('getPuestos')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async puestoActivos({commit, dispatch}) {
            return await PuestosApi.listarActivos()
                            .then( response => {
                                commit('set_puestosActivos', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true});
                            })
        }
    }
}